import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { SvgIcon } from '../svg-icon'

import styles from './address-pin-icon.module.css'

const shadowPath = 'M24,44.5c-2.4,0-4.4-1-4.4-2.2s2-2.2,4.4-2.2s4.4,1,4.4,2.2S26.4,44.5,24,44.5z'
const borderPath = `M36,8.4c-6.7-6.6-17.4-6.6-24,0c-6.6,6.5-6.6,17.2-0.1,23.8c0,0,0.1,0.1,0.1,0.1c3.1,
3.1,12,10,12,10s8.9-7,12-10c6.6-6.5,6.6-17.2,0.1-23.8C36.1,8.5,36.1,8.4,36,8.4`
const backgroundPath = `M35,9.5c-6.1-6-15.9-6-22,0c-6,6-6.1,15.7-0.1,21.7c0,0,0.1,0.1,0.1,0.1c2.8,2.8,
11,9.2,11,9.2s8.2-6.4,11-9.2c6-6,6.1-15.7,0.1-21.7C35.1,9.6,35,9.6,35,9.5`
const addressPath = `M29.4,13.2l-4.8,2.4c-0.2,0.1-0.4,0.1-0.6-0.1C24,15.4,24,15.3,24,15.2v-1.6c0-0.2-0.1-0.4-0.3-0.5
c-0.1,0-0.2,0-0.3,0.1l-4.8,2.4c-0.4,0.2-0.6,0.6-0.6,1v12h12v-15c0-0.2-0.2-0.4-0.4-0.4C29.5,13.1,29.4,13.2,29.4,13.2z
 M23.2,26.3h-3v-3h3V26.3z M23.2,21h-3v-3h3V21z M27.7,26.3h-3v-3h3V26.3z M27.7,21h-3v-3h3V21z`

const propTypes = {
    addressClassName: PropTypes.string,
    backgroundStyle: PropTypes.objectOf(PropTypes.string),
    borderClassName: PropTypes.string,
    className: PropTypes.string,
    foregroundStyle: PropTypes.objectOf(PropTypes.string),
    shadowClassName: PropTypes.string
}

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48,
    width: 36
}

/**
 * Stateless function representing a address pin icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @param {string} [props.addressClassName] - The class name for the address icon
 * @param {Object} [props.backgroundStyle] - The style object for the background svg path
 * @param {string} [props.borderClassName] - The class name for the border outline
 * @param {string} [props.className] - The class name for the svg element
 * @param {string} [props.shadowClassName] - The class name for the shadow
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AddressPinIcon width={12} />
 */
const AddressPinIcon = function (props) {
    const { addressClassName, backgroundStyle, borderClassName, className, foregroundStyle, shadowClassName } = props
    const combinedClassnames = cx(className, styles['address-pin'])

    return (
        <SvgIcon {...props} className={combinedClassnames}>
            <path className={cx(styles['address-pin-shadow'], shadowClassName)} d={shadowPath} />
            <path className={cx(styles['address-pin-border'], borderClassName)} d={borderPath} />
            <path className={cx(styles['address-pin-background'])} style={backgroundStyle} d={backgroundPath} />
            <path
                className={cx(styles['address-pin-address'], addressClassName)}
                style={foregroundStyle}
                d={addressPath}
            />
        </SvgIcon>
    )
}

AddressPinIcon.defaultProps = defaultProps
AddressPinIcon.propTypes = propTypes

export { AddressPinIcon }
